import { useMemo, useState } from "react";
import { cn } from "@/lib/utils";

export function NumberInput({
  onChange,
  defaultValue,
  min,
  max,
  integer,
}: {
  onChange?: (value: number) => void;
  defaultValue?: number;
  min?: number;
  max?: number;
  integer?: boolean;
}) {
  const [error, setError] = useState<string | null>(null);

  return (
    <div className="min-w-0 space-y-2">
      <input
        defaultValue={defaultValue}
        onChange={(e) => {
          const value = Number(e.target.value);

          if (e.target.value === "" || isNaN(value)) {
            setError("Invalid value");
            return;
          }

          if (min !== undefined && value < min) {
            setError("Value is too low");
            return;
          }

          if (max !== undefined && value > max) {
            setError("Value is too high");
            return;
          }

          if (integer && !Number.isInteger(value)) {
            setError("Value must be an integer");
            return;
          }

          setError(null);
          onChange?.(value);
        }}
        className={cn(
          "w-full min-w-0 rounded-lg bg-white/10 border border-white/20 px-3 py-2 text-white focus:outline-none box-border",
          {
            "focus:ring-2 focus:ring-emerald-500/50": !error,
            "ring-2 ring-red-500/50": error,
          },
        )}
      />
      {error && <p className="text-red-500">{error}</p>}
    </div>
  );
}
